import "./shared/disgusting-hack-against-cleeng-adyen.css";
import "react-loading-skeleton/dist/skeleton.css";
import { FC, useEffect } from "react";
import { StyleSheetManager, ThemeProvider } from "styled-components";
import isPropValid from "@emotion/is-prop-valid";
import { SkeletonTheme } from "react-loading-skeleton";
import { RouterProvider } from "react-router";
import { appRouter } from "@/router";
import { darkTheme, defaultTheme } from "@motain/web-shared-hub/themes";
import { GlobalStyles } from "@motain/web-shared-hub/ui/elements";
import {
  selectIsDarkTheme,
  toggleDarkTheme,
} from "@motain/web-shared-hub/services";
import {
  authenticate,
  checkAuthCookie,
  useGetLocationQuery,
} from "@motain/web-shared-hub/features";
import { useAppDispatch, useAppSelector } from "@/shared/hooks/appHooks";
import { useInitTrackingPayments } from "@features/tracking/hooks/useInitTrackingPayments";
export const App: FC = () => {
  const isDarkMode = useAppSelector(selectIsDarkTheme);
  useInitTrackingPayments();
  useGetLocationQuery();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const isDark = localStorage.getItem("isDarkTheme");
    if (isDark !== null) {
      dispatch(toggleDarkTheme(JSON.parse(isDark)));
    }

    dispatch(authenticate(checkAuthCookie()));
  }, [dispatch]);

  const ThemeColor = isDarkMode ? darkTheme : defaultTheme;

  return (
    <StyleSheetManager shouldForwardProp={isPropValid} enableVendorPrefixes>
      <ThemeProvider theme={ThemeColor}>
        <SkeletonTheme>
          <GlobalStyles />
          <RouterProvider router={appRouter} />
        </SkeletonTheme>
      </ThemeProvider>
    </StyleSheetManager>
  );
};
